// URLs uploaded from the photos field that no saved post references yet.
// PostImagesField deletes them if the form drops them; saving a post removes
// its URLs from the set. Module-level so it survives the form remounting.
export const unsavedUploads = new Set<string>();
